import actions from './actions'

const defaultState = {
  embeddedReportName: '',
  fetching: false
}

const reportViewer = (state = defaultState, action) => {
  switch (action.type) {
    case actions.set:
      return { ...state, embeddedReportName: action.embeddedReportName }
    case actions.fetchSucceeded:
      return { ...state, embeddedReport: action.report, fetching: false, succeeded: true }
    case actions.clear:
      return { ...state, embeddedReport: '', fetching: false, succeeded: false }
    case actions.viewed:
      return { ...state, viewed: true }
    case actions.fetching:
      return { ...state, fetching: true, succeeded: false, viewed: false }
    case actions.fetchFailed:
      return { ...state, error: action.error, fetching: false, succeeded: false }
    default:
      return state
  }
}

export default reportViewer



// WEBPACK FOOTER //
// ./src/store/report-viewer/reducer.js